import { capitalize, computed, createElementBlock, h, onMounted, onUpdated, openBlock, ref, render, useSlots } from "vue";
import { DtNotice } from "@dialpad/dialtone-vue";
//#region src/components/renderer/renderer_target.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcRendererTarget" }, {
	props: {
		component: {
			type: Object,
			required: true
		},
		bindings: {
			type: void 0,
			required: true
		},
		events: {
			type: void 0,
			required: true
		}
	},
	emits: ["event"],
	setup(__props, { emit: __emit }) {
		const ERROR_MESSAGE = "Error rendering component";
		const props = __props;
		const emit = __emit;
		const slots = useSlots();
		/**
		* Map object containing events and their respective handlers.
		*
		* @returns {ComputedRef<object>} Event map.
		*/
		const events = computed(() => {
			if (!props.events) return {};
			return Object.fromEntries(props.events.map(({ name }) => {
				return [`on${capitalize(name)}`, (e) => emit("event", name, e)];
			}));
		});
		onMounted(renderTarget);
		onUpdated(renderTarget);
		const wrapper = ref();
		/**
		* Destroys any old containers in the wrapper and appends a new one.
		* Not completely sure why this has to be done, but it is buggy
		* if this method is not used.
		*
		* @returns {HTMLDivElement} Instantiated container for rendering.
		*/
		function nextContainer() {
			wrapper.value.replaceChildren();
			return wrapper.value.appendChild(document.createElement("div"));
		}
		/**
		* Need to render manually to catch DOM exception errors.
		*
		* Attempts to render the target component, if there is
		* an error a warning will be logged and a 'notice' component
		* will be rendered to inform the user.
		*/
		function renderTarget() {
			const container = nextContainer();
			try {
				render(h(props.component, {
					...props.bindings,
					...events.value
				}, slots), container);
			} catch (e) {
				console.warn("Rendering warning: \n", e);
				renderError(e, container);
			}
		}
		/**
		* Renders the error 'notice' component.
		*
		* @param exception - The exception.
		* @param container - The container to render in.
		*/
		function renderError(exception, container) {
			render(h(DtNotice, {
				kind: "error",
				hideClose: true,
				title: ERROR_MESSAGE
			}, { default: () => exception.toString() }), container);
		}
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", {
				ref_key: "wrapper",
				ref: wrapper
			}, null, 512);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=renderer_target.vue.js.map